/**
 * Снимает маску с телефона: убирает пробелы, скобки, дефисы
 */
export const removePhoneMask = (value: string): string => value.replace(/[\s()\-]/g, '')

/**
 * Нормализует телефон к формату +7XXXXXXXXXX
 */
export const normalizePhone = (phone: string | null | undefined): string => {
	if (!phone) return ''
	let cleaned = removePhoneMask(phone)
	if (cleaned.startsWith('8')) {
		cleaned = '+7' + cleaned.slice(1)
	}
	if (!cleaned.startsWith('+')) {
		cleaned = '+' + cleaned
	}
	return cleaned
}
